import { useId } from "react";

const STOP_TRANSITION_STYLE = {
  transition: "stop-color 300ms ease-in-out",
};

const SVG_VARIANTS = [
  {
    className: "hidden md:block absolute",
    width: "2080",
    height: "379",
    viewBox: "0 0 2080 379",
    path: "M0 0H2080V354.388C2080 354.388 1754 300.776 1040 354.388C326 408 0 354.388 0 354.388V0Z",
    gradientId: "paint0_linear_8_2",
  },
  {
    className: "md:hidden absolute",
    width: "770",
    height: "364",
    viewBox: "0 0 770 364",
    path: "M0 0H770V354.616C770 354.616 648.853 333.501 385 354.616C121.147 375.73 0 354.616 0 354.616V0Z",
    gradientId: "paint0_linear_8_4",
  },
];

function getGradientStops(stops) {
  return stops.map((color, idx) => ({
    color,
    offset: stops.length === 1 ? 0 : idx / (stops.length - 1),
  }));
}

function renderGradientStops(stops) {
  return stops.map(({ color, offset }) => (
    <stop
      key={`stop-${offset}`}
      offset={offset}
      stopColor={color}
      style={STOP_TRANSITION_STYLE}
    />
  ));
}

export default function GradientBackdrop({ bgColors, bgColor }) {
  const gradientIdPrefix = useId();
  const stopsRaw =
    bgColors && bgColors.length > 0
      ? bgColors
      : [bgColor ?? "#000000", bgColor ?? "#000000"];
  const stops = stopsRaw.length === 1 ? [stopsRaw[0], stopsRaw[0]] : stopsRaw;
  const gradientStops = getGradientStops(stops);

  return (
    <>
      {SVG_VARIANTS.map((variant) => {
        const gradientId = `${gradientIdPrefix.replaceAll(":", "")}-${variant.gradientId}`;
        return (
          <svg
            key={variant.gradientId}
            className={variant.className}
            width={variant.width}
            height={variant.height}
            viewBox={variant.viewBox}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: "auto", height: "100%" }}
          >
            <path d={variant.path} fill={`url(#${gradientId})`} />
            <defs>
              <linearGradient
                id={gradientId}
                x1="323.5"
                y1="0"
                x2="323.5"
                y2="364"
                gradientUnits="userSpaceOnUse"
              >
                {renderGradientStops(gradientStops)}
              </linearGradient>
            </defs>
          </svg>
        );
      })}
    </>
  );
}
